'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _webSso = require('@vezeeta/web-sso');

var _Filter = require('@vezeeta/enterprise-utils/lib/Filter');

var _Filter2 = _interopRequireDefault(_Filter);

var _Clinics = require('@vezeeta/enterprise-utils/lib/Clinics');

var _Clinics2 = _interopRequireDefault(_Clinics);

var _room = require('../actions/room');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(filterWorkingHours),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getRoomDetails),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(getRoomsSaga),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(addRoomSaga),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(deleteRoomSaga),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(updateRoomSaga),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(getDoctorShiftsSaga),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(assignDcotorShiftsToRoomSaga),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(getRoomsCalendarViewSaga),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(roomSaga);

function filterWorkingHours(action) {
  var allShifts;
  return _regenerator2.default.wrap(function filterWorkingHours$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _Filter2.default.filterClinics(action.days, action.filterData);

        case 2:
          allShifts = _context.sent;
          _context.next = 5;
          return (0, _effects.put)({ type: _room.ROOM.FILTER_SUCCESS, allShifts: allShifts });

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getRoomDetails(action) {
  var apiScheduleTypes, apiReservationWindow, clinicsData, accountKey, apiBody, apiCalls, apiResponses, scheduleTypes;
  return _regenerator2.default.wrap(function getRoomDetails$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          apiScheduleTypes = new _webSso.AuthApi();
          apiReservationWindow = new _webSso.AuthApi();
          clinicsData = _Clinics2.default.flattenClinics(action.clinics);
          accountKey = void 0;
          apiBody = [];


          if (action.loadAllDoctors) {
            // Should get working Hours for all doctors and rooms
            clinicsData.rooms.forEach(function (room) {
              room.Doctors.forEach(function (doctor) {
                return apiBody.push({
                  AccountKey: doctor.AccountKey,
                  RoomKey: room.RoomKey
                });
              });
            });
          } else {
            // To maintain backward compatibility with old working hours
            accountKey = clinicsData.doctors[0].AccountKey;
            apiBody = clinicsData.rooms.map(function (room) {
              return {
                AccountKey: accountKey,
                RoomKey: room.RoomKey
              };
            });
          }

          apiCalls = [{ call: apiScheduleTypes, url: _webUtils.Urls.getScheduleTypes }, { call: apiReservationWindow, url: _webUtils.Urls.getAllowReservationWindow }];
          _context2.next = 9;
          return apiCalls.map(function (apiCall) {
            return apiCall.call.post(apiCall.url, apiBody);
          });

        case 9:
          apiResponses = _context2.sent;

          if (!(_webUtils.STATUS.isSuccess(apiResponses[0].status) && _webUtils.STATUS.isSuccess(apiResponses[1].status))) {
            _context2.next = 17;
            break;
          }

          scheduleTypes = [];

          apiBody.forEach(function (doctorAndRoom, index) {
            var scheduleType = apiResponses[0].data[index];
            scheduleType.RoomKey = doctorAndRoom.RoomKey;
            scheduleTypes.push(scheduleType);
          });

          _context2.next = 15;
          return (0, _effects.put)((0, _room.getRoomDetailsSuccess)(scheduleTypes, apiResponses[1]));

        case 15:
          _context2.next = 19;
          break;

        case 17:
          _context2.next = 19;
          return (0, _effects.put)((0, _room.getRoomDetailsFail)('Failed to load room details'));

        case 19:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function getRoomsSaga(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function getRoomsSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context3.next = 5;
          return api.get(_webUtils.Urls.getRooms + '/' + action.payload.branchKey + '/physicalrooms', header);

        case 5:
          response = _context3.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context3.next = 11;
            break;
          }

          _context3.next = 9;
          return (0, _effects.put)((0, _room.getRoomsSuccess)(_extends({}, response)));

        case 9:
          _context3.next = 13;
          break;

        case 11:
          _context3.next = 13;
          return (0, _effects.put)((0, _room.getRoomsFail)());

        case 13:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function addRoomSaga(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function addRoomSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context4.next = 5;
          return api.post(_webUtils.Urls.addRoom + '/' + action.payload.branchKey + '/physicalroom', action.payload.room, header);

        case 5:
          response = _context4.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context4.next = 11;
            break;
          }

          _context4.next = 9;
          return (0, _effects.put)((0, _room.addRoomSucces)(_extends({}, response.data)));

        case 9:
          _context4.next = 13;
          break;

        case 11:
          _context4.next = 13;
          return (0, _effects.put)((0, _room.addRoomFail)(_extends({}, response)));

        case 13:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function deleteRoomSaga(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function deleteRoomSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context5.next = 5;
          return api.delete(_webUtils.Urls.deleteRoom + '/' + action.payload.roomKey, header);

        case 5:
          response = _context5.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context5.next = 11;
            break;
          }

          _context5.next = 9;
          return (0, _effects.put)((0, _room.deleteRoomSuccess)(_extends({}, response.response, action.payload)));

        case 9:
          _context5.next = 13;
          break;

        case 11:
          _context5.next = 13;
          return (0, _effects.put)((0, _room.deleteRoomFail)(_extends({}, response)));

        case 13:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function updateRoomSaga(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function updateRoomSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context6.next = 5;
          return api.put(_webUtils.Urls.editRoom + '/' + action.payload.roomKey, action.payload.room, header);

        case 5:
          response = _context6.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context6.next = 11;
            break;
          }

          _context6.next = 9;
          return (0, _effects.put)((0, _room.editRoomSucces)(_extends({}, response.response, action.payload)));

        case 9:
          _context6.next = 13;
          break;

        case 11:
          _context6.next = 13;
          return (0, _effects.put)((0, _room.editRoomFail)(_extends({}, response)));

        case 13:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function getDoctorShiftsSaga(action) {
  var api, authToken, culture, header, response;
  return _regenerator2.default.wrap(function getDoctorShiftsSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);

          culture = 'en-' + culture.split('-')[1];

          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'actionsource',
            value: 'ScheduleWeb'
          }, {
            key: 'language',
            value: '' + culture
          }];
          _context7.next = 7;
          return api.post('' + _webUtils.Urls.getDoctorWorkingHoursShiftsAndRooms, action.payload, header);

        case 7:
          response = _context7.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context7.next = 13;
            break;
          }

          _context7.next = 11;
          return (0, _effects.put)((0, _room.getDoctorWorkingHoursShiftSuccess)(_extends({}, response.data)));

        case 11:
          _context7.next = 15;
          break;

        case 13:
          _context7.next = 15;
          return (0, _effects.put)((0, _room.getDoctorWorkingHoursShiftFail)(_extends({}, response)));

        case 15:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function assignDcotorShiftsToRoomSaga(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function assignDcotorShiftsToRoomSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context8.next = 5;
          return api.put('' + _webUtils.Urls.assignShiftToRoom, action.payload, header);

        case 5:
          response = _context8.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context8.next = 11;
            break;
          }

          _context8.next = 9;
          return (0, _effects.put)((0, _room.assignDoctorShiftToRoomSuccess)(_extends({}, response.response)));

        case 9:
          _context8.next = 13;
          break;

        case 11:
          _context8.next = 13;
          return (0, _effects.put)((0, _room.assignDoctorShiftToRoomFail)(_extends({}, response)));

        case 13:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function getRoomsCalendarViewSaga(action) {
  var api, authToken, culture, header, roomKeysString, dateString, response;
  return _regenerator2.default.wrap(function getRoomsCalendarViewSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);

          culture = 'en-' + culture.split('-')[1];

          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'language',
            value: '' + culture
          }];

          // daysOfWeekString Not used any more
          /* let daysOfWeekString = '';
          if (action.payload.daysOfWeek && action.payload.daysOfWeek.length) {
            daysOfWeekString = `DayOfWeek=${action.payload.daysOfWeek.join(',')}`;
          } */

          roomKeysString = '';

          if (action.payload.roomKeys && action.payload.roomKeys.length) {
            action.payload.roomKeys.forEach(function (roomkey) {
              roomKeysString = roomKeysString + '&phroomkeys=' + roomkey;
            });
          }

          dateString = '';

          if (action.payload.startDate && action.payload.endDate) {
            dateString = 'StartDate=' + action.payload.startDate + '&EndDate=' + action.payload.endDate;
          }

          _context9.next = 11;
          return api.get(_webUtils.Urls.getCalendarView + '/' + action.payload.branchKey + '/calendar?' + dateString + roomKeysString, header);

        case 11:
          response = _context9.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context9.next = 17;
            break;
          }

          _context9.next = 15;
          return (0, _effects.put)((0, _room.getRoomsCalendarViewSuccess)(_extends({}, response)));

        case 15:
          _context9.next = 19;
          break;

        case 17:
          _context9.next = 19;
          return (0, _effects.put)((0, _room.getRoomsCalendarViewFail)(_extends({}, response)));

        case 19:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function roomSaga() {
  return _regenerator2.default.wrap(function roomSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_room.ROOM.GET_ROOMS_CALENDAR_VIEW.FETCH, getRoomsCalendarViewSaga);

        case 2:
          _context10.next = 4;
          return (0, _effects.takeEvery)(_room.ROOM.FILTER, filterWorkingHours);

        case 4:
          _context10.next = 6;
          return (0, _effects.takeEvery)(_room.ROOM.GET_ROOM_DETAILS, getRoomDetails);

        case 6:
          _context10.next = 8;
          return (0, _effects.takeEvery)(_room.ROOM.GET_ROOMS.FETCH, getRoomsSaga);

        case 8:
          _context10.next = 10;
          return (0, _effects.takeEvery)(_room.ROOM.ADD_ROOM.SUBMIT, addRoomSaga);

        case 10:
          _context10.next = 12;
          return (0, _effects.takeEvery)(_room.ROOM.DELETE_ROOM.SUBMIT, deleteRoomSaga);

        case 12:
          _context10.next = 14;
          return (0, _effects.takeEvery)(_room.ROOM.UPDATE_ROOM.SUBMIT, updateRoomSaga);

        case 14:
          _context10.next = 16;
          return (0, _effects.takeEvery)(_room.ROOM.GET_DOCTOR_SHIFTS_ROOMS.FETCH, getDoctorShiftsSaga);

        case 16:
          _context10.next = 18;
          return (0, _effects.takeEvery)(_room.ROOM.ASSIGN_DOCTOR_SHIFTS_TO_ROOMS.SUBMIT, assignDcotorShiftsToRoomSaga);

        case 18:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

exports.default = roomSaga;
module.exports = exports['default'];